import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { UploaderMethodProps } from '#src/app/shared/components/imageUpload';

import { uploadImage } from '../uploadImage';

import { AiImageForPetitionJob } from './api.graphql';
import type { AiImageForPetitionJobQuery, AiImageForPetitionJobQueryVariables } from './api.graphql';

export type AiImageJobResult =
	| { status: 'ERROR'; errorReason: string }
	| { status: 'IN_PROGRESS' }
	| { status: 'COMPLETED'; image: string };

export async function aiImageForPetitionJob(
	responseId: string | null | undefined,
	uploader: UploaderMethodProps,
	utilityContext: UtilityContext,
): Promise<AiImageJobResult> {
	const { fetch } = utilityContext.gql;

	if (!responseId) {
		throw new Error('No responseId provided');
	}

	const { data } = await fetch<AiImageForPetitionJobQuery, AiImageForPetitionJobQueryVariables>({
		query: AiImageForPetitionJob,
		variables: { input: { responseId } },
		rejectOnError: true,
	});

	if (data.aiImageForPetitionJob.__typename === 'AiImageForPetitionJobError') {
		throw new Error(data.aiImageForPetitionJob.reason);
	}

	if (data.aiImageForPetitionJob.__typename === 'AiImageForPetitionJobInProgress') {
		return { status: 'IN_PROGRESS' };
	}

	const result = await uploadImage(uploader, data.aiImageForPetitionJob.image, utilityContext);

	return { status: 'COMPLETED', image: result.uploadURL ?? '' };
}
